module.exports = __webpack_public_path__ + "static/media/cap.38448653.png";